<template>
  <div>
    <headerSection />

    <div class="container py-4">
      <div class="d-flex mb-2">
        <div class="d-flex flex-1 border-bottom border-blue-main-toeic">
          <a class="p-2 d-inline-block font-bold pointer mr-2 border border-blue-main-toeic" @click="selectEn = true" :class="{ 'bg-blue-lighter-toeic text-white': selectEn, 'text-blue-main-toeic': !selectEn }">英文成績證明</a>
          <a class="p-2 d-inline-block font-bold pointer mr-2 border border-blue-main-toeic" @click="selectEn = false" :class="{ 'bg-blue-lighter-toeic text-white': !selectEn, 'text-blue-main-toeic': selectEn }">中文成績證明</a>
        </div>
        <div class="text-center">
          <a class="bg-blue-lighter-toeic text-white px-4 py-2 d-inline-block font-bold text-xl pointer mx-2 rounded">證書下載</a>
          <router-link :to="{ name: 'detailed_explanation', params: { record_id: $route.params.record_id } }" class="bg-blue-lighter-toeic text-white px-4 py-2 d-inline-block font-bold text-xl pointer mx-2 rounded">查看詳解</router-link>
        </div>
      </div>
      <!-- Title -->
      <div class="">
        <div class="mb-2 p-2 px-2 bg-white">
          <p class="text-blue-main-toeic text-left mb-1 font-semibold">Speaking Test</p>
          <h3 class="text-center font-bold">TEST 1 SCORE CERTIFICATE</h3>
        </div>
        <!-- Top Section -->
        <div class="row mx-0 mb-2">
          <!-- Left Info -->
          <div class="col-md-6 text-left bg-white">
            <div class="">
              <div class="py-3">
                <div class="border-bottom pb-1">NAME</div>
                <div class="mb-3 text-lg font-bold">諸伏高明</div>

                <div class="border-bottom pb-1">TEST DATE (yyyy/mm/dd)</div>
                <div class="text-lg font-bold">2025/08/08</div>
              </div>

              <div class="py-3">
                <div class="text-blue-main-toeic text-xl font-semibold mb-1">Pronunciation : <span class="text-orange-main-toeic">Medium</span></div>
                <p class="text-lg font-semibold mb-3">When reading aloud, the pronunciation is generally understandable, but occasional mistakes occur.</p>

                <div class="text-blue-main-toeic text-xl font-semibold mb-1">Intonation and Stress : <span class="text-orange-main-toeic">Medium</span></div>
                <p class="text-lg font-semibold">When reading aloud, the use of intonation and stress is mostly appropriate.</p>
              </div>
            </div>
          </div>

          <!-- Right Score -->
          <div class="col-md-6 text-center bg-white">
            <div class="p-3">
              <div class="d-flex justify-content-center mb-5 block">
                <gaugeCanvas  />
              </div>
              <div class="block pt-5">
                <div class="text-xl border-bottom pb-2 rounded">Speaking proficiency level is 7.</div>
                <div class="font-weight-bold text-orange-main-toeic mt-2 text-2xl rounded">CEFR B2</div>
              </div>
            </div>
          </div>
        </div>
        <!-- Bottom Section -->
        <div class="row mx-0">
          <!-- Radar chart placeholder -->
          <div class="col-md-6 text-lg pb-3 bg-white">
            <div class="p-2 w-auto d-flex">
              <img src="@/assets/image/toeic/toeic_exam/Capability_analysis.png" alt="" class="object-contain">
            </div>
            <radarChart />
          </div>

          <!-- Text Description -->
          <div class="col-md-6 text-left text-xl bg-white py-3">
            <p class="font-semibold text-xl">Your scaled score is between 160 and 180.</p>
            <p class="text-left">
              Test takers in this score range typically can produce connected and sustained speech suitable for common workplace situations. They are able to express opinions and handle complex requests effectively. In longer responses, a few small issues may appear, such as
            </p>
            <ul class="text-left font-semibold">
              <li>minor pronunciation, intonation, or hesitation difficulties</li>
              <li>occasional mistakes when using complex grammar structures</li>
              <li>some word choices that are not fully precise</li>
            </ul>
            <p class="text-left">
              These minor issues do not affect the overall clarity of the message.Test takers in this score range can also answer questions and provide basic information with ease.
              When reading aloud, their speech is clear and easy to understand.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
  import { mapActions, mapGetters } from 'vuex'
  import headerSection from '@/components/AiHelper/toeic/headerSection'
  import gaugeCanvas from '@/components/AiHelper/toeic/gaugeCanvas'
  import speakingLevels from '@/components/AiHelper/toeic/speakingLevels.js'
  import radarChart from '@/components/AiHelper/toeic/radarChart'
  import api from '@/store/api'
  export default {
    name: 'report',
    components: {
      headerSection,
      gaugeCanvas,
      radarChart
    },
    data () {
      return {
        reportData: null,
        selectEn: true,
        speakingLevelsData: speakingLevels
      }
    },
    watch: {
    },
    computed: {
      ...mapGetters([
        'remainPoints'
      ]),
      currentLevelData () {
        if (this.reportData && this.reportData.key === 'toeic') {
          return this.speakingLevelsData.toeic
        }
        return this.speakingLevelsData.bridge
      },
      currentLevel () {
        const score = this.reportData?.total_score || 0;
        return this.currentLevelData.find(level => {
          const [min, max] = level.score_range.split('-').map(Number);
          return score >= min && score <= max;
        }) || null;
      }
    },
    mounted() {
      this.getData()
    },
    methods: {
      ...mapActions({
        doGetPoints: 'getRemainPoints'
      }),
      getData () {
        let path = `/assessments/records/${this.$route.params.record_id}`

        api.get(path)
        .then((res) => {
          this.reportData = res.data
        })
        .catch((err) => {
        })
      }
    }
  }
</script>
<style lang="scss" scoped>
a {
  &:hover {
    text-decoration: none !important;
  }
}
</style>
